<template>
  <div v-if="errorMessage" class="content alert alert-danger" role="alert">
    <h4 class="alert-heading">An error has occured</h4>
    <p>{{ errorMessage }}</p>
  </div>
  <div class="content d-flex flex-grow">
    <h1 v-if="gift.name" class="content-title flex-grow-1">
      {{ gift.name }}
    </h1>
    <h1 v-else class="content-title flex-grow-1">New Gift</h1>
  </div>
  <form
    class="card"
    @submit.prevent="giftId ? saveGift(gift) : addGift(gift)"
    autocomplete="off"
  >
    <fieldset class="form-group">
      <label class="w-full text-xl p-2" for="name">What do you want?</label>
      <input
        class="form-control"
        type="text"
        id="name"
        name="name"
        v-model="gift.name"
        required
      />
    </fieldset>
    <fieldset class="form-group">
      <label class="w-full text-xl p-2" for="name"
        >Any more details to add?</label
      >
      <textarea
        class="form-control"
        id="description"
        name="description"
        v-model="gift.description"
      ></textarea>
    </fieldset>
    <fieldset class="form-group">
      <label class="w-full text-xl p-2" for="name">Link URL</label>
      <input
        class="form-control"
        type="url"
        id="linkUrl"
        name="linkUrl"
        v-model="gift.linkUrl"
      />
    </fieldset>
    <fieldset class="form-group">
      <label class="w-full text-xl p-2" for="name">Image URL</label>
      <input
        class="form-control"
        type="url"
        id="imageUrl"
        name="imageUrl"
        v-model="gift.imageUrl"
      />
    </fieldset>
    <fieldset class="d-flex flex-row">
      <input
        class="btn btn-primary mx-10"
        type="submit"
        id="description"
        name="description"
        :value="this.giftId ? 'Save gift' : 'Create new gift'"
      />
      <a @click="$router.back()" class="btn mx-10">Cancel</a>
      <div class="flex-grow-1 text-right">
        <a
          v-if="giftId && !confirmDeletion"
          @click="confirmDelete(gift)"
          class="btn btn-danger mx-10"
          >Delete</a
        >
        <a
          v-if="giftId && confirmDeletion"
          @click="deleteGift(gift)"
          class="btn btn-danger mx-10"
          >Are you sure?</a
        >
      </div>
    </fieldset>
  </form>
</template>

<script>
import { db, auth, firebase } from "../../../lib/firebase.js";

export default {
  name: "EditGift",
  components: {},
  props: ["giftId", "eventId"],
  data() {
    return {
      gift: {
        id: this.giftId,
        name: "",
        description: "",
        event: this.eventId,
        linkUrl: "",
        imageUrl: "",
        owner: {},
      },
      events: [],
      confirmDeletion: false,
      errorMessage: null,
    };
  },
  computed: {
    userId: function() {
      return this.$store.getters.getUser.uid;
    },
    activeEvents: function() {
      return this.events.filter((event) => {
        return !event.deleted;
      });
    },
  },
  methods: {
    async getEvents() {
      try {
        const querySnapshot = await db
          .collection("events")
          .where("members", "array-contains", this.userId)
          .orderBy("name")
          .get();
        return querySnapshot.docs.map((doc) => {
          let event = doc.data();
          event.id = doc.id;
          return event;
        });
      } catch (error) {
        this.errorMessage = error.message;
        return null;
      }
    },
    async getGift(giftId) {
      try {
        const eventRef = db.collection("events").doc(this.eventId);
        const giftRef = eventRef.collection("gifts").doc(giftId);
        const doc = await giftRef.get();
        var gift = doc.data();
        gift.id = doc.id;
        return gift;
      } catch (error) {
        this.errorMessage = error.message;
        return null;
      }
    },
    async addGift(gift) {
      try {
        const eventRef = db.collection("events").doc(this.eventId);
        this.gift.owner = {
          id: auth.currentUser.uid,
          name: auth.currentUser.displayName,
        };
        delete gift.id;
        await eventRef.collection("gifts").add(this.gift);
        firebase.analytics().logEvent("gift_created");
        window.analytics.track("Gift created", {
          gift: gift,
        });
        this.$router.back();
      } catch (error) {
        this.errorMessage = error.message;
      }
    },
    async saveGift(gift) {
      try {
        const eventRef = db.collection("events").doc(this.eventId);
        await eventRef
          .collection("gifts")
          .doc(gift.id)
          .set(gift);
        this.$router.back();
      } catch (error) {
        this.errorMessage = error.message;
      }
    },
    async deleteGift(gift) {
      try {
        const eventRef = db.collection("events").doc(this.eventId);
        await eventRef
          .collection("gifts")
          .doc(gift.id)
          .update({ deleted: true });
        this.confirmDeletion = false;
        this.$router.back();
      } catch (error) {
        this.errorMessage = error.message;
      }
    },
    confirmDelete() {
      this.confirmDeletion = true;
    },
  },
  async mounted() {
    if (this.giftId) {
      const gift = await this.getGift(this.giftId);
      this.gift = gift;
    }
    this.events = await this.getEvents();
  },
};
</script>
